import { InjectionToken } from '@angular/core';
import type { BulkActionExecutor } from './bulk-action-executor.interfaces';

export const BULK_ACTION_EXECUTOR = new InjectionToken<BulkActionExecutor | null>(
  'BULK_ACTION_EXECUTOR',
);
